import { createI18n } from 'vue-i18n';
import en from './en.json';
import de from './de.json';

const STORAGE_KEY = 'libretto42:locale';

export type SupportedLocale = 'en' | 'de';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['en', 'de'];

function detectLocale(): SupportedLocale {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'en' || stored === 'de') return stored;
  const nav = typeof navigator !== 'undefined' ? navigator.language : 'en';
  if (nav.startsWith('de')) return 'de';
  return 'en';
}

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: { en, de },
});

export function setLocale(next: SupportedLocale): void {
  i18n.global.locale.value = next;
  localStorage.setItem(STORAGE_KEY, next);
  document.documentElement.lang = next;
}
